window.dataLayer = window.dataLayer || [];
window.formStartEvent = formStartEvent;
window.formStartStepEvent = formStartStepEvent;
window.formSubmitStepEvent = formSubmitStepEvent;
window.formCompleteEvent = formCompleteEvent;
window.vacancyClicked = vacancyClicked;
window.jobboardSearchQuery = jobboardSearchQuery;
window.vacancyShared = vacancyShared;

let formStarted = false;

const pageId = document.currentScript.getAttribute('data-pageId')
const pageName = document.currentScript.getAttribute('data-pageName');
const documentType = document.currentScript.getAttribute('data-documentType');

// window_loaded
document.addEventListener("DOMContentLoaded", () => {
    dataLayer.push({
        "event": "page_view",
        "data": {
            "language": `${document.documentElement.lang}`,
            "page": `${pageId}`,
            "page_name": `${pageName}`,
            "page_type": `${documentType}`
        }
    });
});

// search_query
function jobboardSearchQuery(query, totalCount) {
    dataLayer.push({
        "event": "search_query",
        "data": {
            "level_1": "search",
            "level_2": "query",
            "level_3": hasValue(query.Keyword),
            "level_4": hasValue(query.Language),
            "level_5": hasValue(query.Location),
            "level_6": hasValue(query.Radius),
            "level_7": hasValue(query.PostalCodes),
            "level_8": hasValue(query.Companies),
            "level_9": hasValue(query.Mediums),
            "level_10": hasValue(query.ScheduleTypes),
            "level_11": hasValue(query.ContractTypes),
            "level_12": hasValue(query.JobFunctions),
            "level_13": hasValue(query.Branches),
            "level_14": hasValue(query.Sort),
            "level_15": hasValue(query.Since),
            "level_16": `${totalCount}`
        }
    })
}

function vacancyClicked(totalCount, index, query, title, pubId) {
    dataLayer.push({
        "event": "search_result_click",
        "data": {
            "level_1": "search",
            "level_2": "result_click",
            "level_3": hasValue(query.Keyword),
            "level_4": hasValue(query.Language),
            "level_5": hasValue(query.Location),
            "level_6": hasValue(query.Radius),
            "level_7": hasValue(query.PostalCodes),
            "level_8": hasValue(query.Companies),
            "level_9": hasValue(query.Mediums),
            "level_10": hasValue(query.ScheduleTypes),
            "level_11": hasValue(query.ContractTypes),
            "level_12": hasValue(query.JobFunctions),
            "level_13": hasValue(query.Branches),
            "level_14": hasValue(query.Sort),
            "level_15": hasValue(query.Since),
            "level_16": `${totalCount}`,
            "level_17": hasValue(query.Page),
            "level_18": `${index}`,
            "level_19": `${title}`,
            "level_20": `${pubId}`,
        }
    })
}

function formStartEvent(formStartEventOptions) {
    if (formStarted === true) {
        return;
    }

    dataLayer.push({
        "event": `form_${formStartEventOptions.formName}_form_start`,
        "data": {
            "level_1": "form",
            "level_2": "form_start",
            "level_3": `${formStartEventOptions.formName}`,
            "level_4": `${formStartEventOptions.stepNumber}`,
            "level_5": `${pageName}`
        }
    });

    formStarted = true
}

function formStartStepEvent(formStartStepEventOptions) {
    dataLayer.push({
        "event": `form_${formStartStepEventOptions.formName}_step_start`,
        "data": {
            "level_1": "form",
            "level_2": "step_start",
            "level_3": `${formStartStepEventOptions.formName}`,
            "level_4": `${formStartStepEventOptions.stepNumber}`,
            "level_5": `${pageName}`
        }
    });
}

function formSubmitStepEvent(formSubmitStepEventOptions) {
    dataLayer.push({
        "event": `form_${formSubmitStepEventOptions.formName}_step_submit`,
        "data": {
            "level_1": "form",
            "level_2": "step_start",
            "level_3": `${formSubmitStepEventOptions.formName}`,
            "level_4": `${formSubmitStepEventOptions.stepNumber}`,
            "level_5": `${pageName}`
        }
    });
}

// when completing the form/funnel:
function formCompleteEvent(formCompleteEventOptions) {
    const eventData = {
        "level_1": "form",
        "level_2": "complete",
        "level_3": formCompleteEventOptions.formName,
        "level_4": formCompleteEventOptions.stepNumber,
        "level_5": formCompleteEventOptions.postalCode,
        "level_6": `${pageName}`
    }

    formCompleteEventOptions.selectedValues.forEach((selectedValue) => {
        eventData[`level_${Object.keys(eventData).length + 1}`] = selectedValue.value
    })

    const enhancedConversionsData = {
        "email": formCompleteEventOptions.enhancedConversions.email,
        "phone_number": formCompleteEventOptions.enhancedConversions.phoneNumber,
        "address": {
            "first_name": formCompleteEventOptions.enhancedConversions.firstName
        }
    }


    dataLayer.push({
        "event": `form_${formCompleteEventOptions.formName}_complete`,
        "data": { ...eventData, ...enhancedConversionsData }
    });
}


function vacancyShared(platform, title, pubId) {
    dataLayer.push({
        "event": "vacancy_share_click",
        "data": {
            "level_1": "vacancy",
            "level_2": "share_click",
            "level_3": `${platform}`,
            "level_4": `${title}`,
            "level_5": `${pubId}`,
        }
    })
}

function hasValue(value) {
    if (value == null) return null;
    
    if (Array.isArray(value) && value.length === 0) return null;
    
    if (typeof value === 'string' && value.trim() === '') return null;
    
    if (typeof value === 'object' && Object.keys(value).length === 0) return null;
    
    if (typeof value === 'number' && isNaN(value)) return null;
    
    return value;
};